import React from "react";

const LeftSquare = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      margin="0 6px 0 0"
    >
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM12 18.01C8.83 18.01 6.25 15.43 6.25 12.26C6.25 11.12 6.58 10.01 7.22 9.07C7.45 8.72 7.92 8.63 8.26 8.86C8.6 9.09 8.7 9.56 8.46 9.9C8 10.6 7.75 11.42 7.75 12.26C7.75 14.6 9.66 16.51 12 16.51C14.34 16.51 16.25 14.6 16.25 12.26C16.25 9.92 14.34 8.01 12 8.01C11.81 8.01 11.63 8.03 11.44 8.05L12 8.46C12.33 8.7 12.41 9.17 12.16 9.51C12.01 9.71 11.78 9.82 11.55 9.82C11.4 9.82 11.24 9.77 11.11 9.68L9.17 8.25C9.17 8.25 9.16 8.24 9.15 8.23C9.14 8.22 9.13 8.22 9.12 8.21C9.09 8.19 9.08 8.15 9.05 8.12C9.02 8.08 8.99 8.05 8.96 8C8.94 7.96 8.93 7.91 8.91 7.87C8.9 7.82 8.88 7.78 8.88 7.73C8.88 7.68 8.88 7.64 8.89 7.59C8.89 7.54 8.89 7.5 8.91 7.45C8.91 7.4 8.94 7.36 8.96 7.31C8.98 7.28 8.98 7.24 9.01 7.2C9.02 7.2 9.03 7.19 9.04 7.18C9.05 7.17 9.05 7.16 9.06 7.15L10.73 5.24C11 4.93 11.48 4.89 11.79 5.17C12.1 5.44 12.13 5.92 11.86 6.23L11.58 6.55C11.72 6.54 11.86 6.52 12.01 6.52C15.18 6.52 17.76 9.1 17.76 12.27C17.76 15.44 15.17 18.01 12 18.01Z"
        fill={color}
      />
    </svg>
  );
};

export default LeftSquare;
